<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10">
    <tui-badge appearance="neutral" iconStart="@tui.blocks" size="xl">
      Native Builds
    </tui-badge>
  </div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        Build iOS and Android apps<br /><span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >without headaches</span
        >
      } @placeholder {
        Build iOS and Android apps<br />without headaches
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      <span class="hidden md:block"
        >Eliminate days of setup and maintenance. Connect your repository and
        start building iOS and Android apps in minutes—no Mac required, no SDK
        management, just seamless builds.</span
      >
      <span class="md:hidden"
        >Build iOS and Android apps without Mac hardware or SDK management.
        Connect and build in minutes.</span
      >
    </p>
    <div class="flex flex-col items-center gap-3">
      <div class="flex space-x-4">
        <a
          iconEnd="@tui.arrow-right"
          size="l"
          tuiButton
          type="button"
          [href]="consoleBaseUrl"
          target="_blank"
          data-umami-event="native-builds-hero-start-free-button"
        >
          Get started
        </a>
        <a
          appearance="secondary"
          size="l"
          tuiButton
          type="button"
          [href]="bookingUrl"
          target="_blank"
          data-umami-event="native-builds-hero-booking-demo-button"
        >
          Book a demo
        </a>
      </div>
      @if (statistics.data(); as data) {
        <p class="flex items-center gap-1.5 text-sm text-gray-600">
          <span>🔨</span>
          <span
            ><b>{{ data.lastMonthAppBuilds | number }} Native Builds</b>
            completed last month</span
          >
        </p>
      }
    </div>
  </div>
</section>
